// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ZEaO","name":"Header_name__pSUbb","birthday":"Header_birthday__UnLMV","skeleton":"Header_skeleton__2yfqj"};